import { LANGUAGE_ENUMS } from '../../../constants/staticPageConstants';
import { TDropdownList } from '../DynamicHeader/Dropdown/DropdownComponent';
import { DesktopNavBar } from './DesktopHeader';
import { MobileNavBar } from './MobileHeader';

const AeNavbar = ({
  language = LANGUAGE_ENUMS.English,
  LangSwitchLink,
  domain,
}: {
  language?: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  domain: number;
}): JSX.Element => {
  return (
    <>
      <div className={`sm:hidden`} data-testid="ae-navbar">
        <DesktopNavBar
          language={language}
          LangSwitchLink={LangSwitchLink}
          domain={domain}
        />
      </div>
      <div className={`hidden sm:block`}>
        <MobileNavBar
          language={language}
          LangSwitchLink={LangSwitchLink}
          domain={domain}
        />
      </div>
    </>
  );
};

export { AeNavbar };
